<template>
  <div class="container py-5">
    <h2 class="mb-4">Todos os Usuarios</h2>

    <div class="mb-4">
      <button
        class="btn"
        :class="filtro === 'todos' ? 'btn-primary' : 'btn-outline-primary'"
        @click="alternarFiltro('todos')"
      >
        Usuarios
      </button>
      <button
        class="btn ms-2"
        :class="filtro === 'candidatos' ? 'btn-primary' : 'btn-outline-primary'"
        @click="alternarFiltro('candidatos')"
      >
        Candidatos
      </button>
    </div>

    <form
      v-if="filtro === 'candidatos'"
      class="row g-2 align-items-end mb-4"
      @submit.prevent="buscarCandidatos"
    >
      <div class="col-md-8">
        <label for="busca-candidato" class="form-label">Buscar candidato por nome ou e-mail</label>
        <input
          id="busca-candidato"
          v-model.trim="buscaCandidato"
          type="text"
          class="form-control"
          placeholder="Digite parte do nome ou e-mail"
        >
      </div>
      <div class="col-md-4">
        <button class="btn btn-primary w-100" type="submit" :disabled="carregandoBusca">
          {{ carregandoBusca ? 'Buscando...' : 'Buscar candidatos' }}
        </button>
      </div>
    </form>

    <div v-if="usuariosFiltrados.length" class="table-responsive">
      <table class="table table-striped">
        <thead class="table-light">
          <tr>
            <th>Nome</th>
            <th>E-mail</th>
            <th>Tipo</th>
            <th>Acoes</th>
            <th>Avaliacao</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="usuario in usuariosFiltrados" :key="usuario.id">
            <td>{{ usuario.nome }}</td>
            <td>{{ usuario.email }}</td>
            <td>
              <span :class="usuario.tipo === 'admin' ? 'badge px-5 py-2 bg-warning text-dark' : 'badge px-5 py-2 bg-info text-dark'">
                {{ usuario.tipo }}
              </span>
            </td>
            <td>
              <router-link
                class="btn btn-sm btn-outline-primary"
                :to="`/admin/usuario/${usuario.id}`"
              >
                Ver Perfil
              </router-link>

              <button
                v-if="usuario.tipo === 'candidato'"
                class="btn btn-sm btn-outline-warning ms-2"
                @click="promover(usuario.id)"
              >
                Promover a Admin
              </button>
            </td>
            <td>
              <div v-if="logado?.tipo === 'admin' && usuario.tipo === 'candidato'" class="mt-2">
                <div class="d-flex gap-1 align-items-center">
                  <span
                    v-for="nota in 5"
                    :key="nota"
                    @click="avaliarUsuario(usuario.id, nota)"
                    :title="nota + ' estrela' + (nota > 1 ? 's' : '')"
                    :class="['emoji-avaliacao', { selecionado: usuario.avaliacao === nota }]"
                  >
                    {{ emojiPorNota(nota) }}
                  </span>
                </div>
                <small class="text-muted">Avaliacao atual (de 1 a 5, onde 1 e o pior e 5 e o melhor): {{ usuario.avaliacao || 'nenhuma' }}</small>
              </div>
              <div v-else>
                <span>Nao se aplica</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-else class="text-muted">{{ mensagemVazia }}</p>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: 'UsuarioListaVie',
  data() {
    return {
      usuarios: [],
      candidatos: [],
      filtro: 'todos',
      buscaCandidato: '',
      buscouCandidatos: false,
      carregandoBusca: false,
      logado: JSON.parse(localStorage.getItem('usuario')),
    };
  },
  computed: {
    usuariosFiltrados() {
      return this.filtro === 'candidatos' ? this.candidatos : this.usuarios;
    },
    mensagemVazia() {
      if (this.filtro === 'candidatos') {
        if (!this.buscouCandidatos) {
          return 'Digite um nome ou e-mail para buscar candidatos.';
        }

        return 'Nenhum candidato encontrado.';
      }

      return 'Nenhum usuario encontrado.';
    },
  },
  mounted() {
    this.carregarAdmins();
  },
  methods: {
    alternarFiltro(filtro) {
      this.filtro = filtro;
    },
    carregarAdmins() {
      api.get('listar_usuarios.php', {
        params: { tipo: 'admin' },
      })
        .then((res) => {
          this.usuarios = res.data;
        })
        .catch(() => alert('Erro ao carregar usuarios.'));
    },
    buscarCandidatos() {
      if (!this.buscaCandidato) {
        this.candidatos = [];
        this.buscouCandidatos = false;
        return;
      }

      this.carregandoBusca = true;

      api.get('listar_usuarios.php', {
        params: {
          tipo: 'candidato',
          busca: this.buscaCandidato,
        },
      })
        .then((res) => {
          this.candidatos = res.data;
          this.buscouCandidatos = true;
        })
        .catch(() => alert('Erro ao buscar candidatos.'))
        .finally(() => {
          this.carregandoBusca = false;
        });
    },
    promover(id) {
      if (!confirm('Deseja realmente promover este usuario a administrador?')) return;

      api.post('promover_usuario.php', { id })
        .then(() => {
          alert('Usuario promovido com sucesso!');
          this.candidatos = this.candidatos.filter((usuario) => usuario.id !== id);
          this.carregarAdmins();
        })
        .catch(() => alert('Erro ao promover usuario.'));
    },
    emojiPorNota(nota) {
      const icones = ['😠', '🙁', '😐', '🙂', '😄'];
      return icones[nota - 1] || '?';
    },
    avaliarUsuario(id, nota) {
      api.post('avaliar_usuario.php', { id, avaliacao: nota })
        .then(() => {
          const usuario = this.usuariosFiltrados.find((item) => item.id === id);
          if (usuario) usuario.avaliacao = nota;
          alert('Avaliacao registrada com sucesso!');
        })
        .catch(() => alert('Erro ao salvar avaliacao.'));
    },
  },
};
</script>

<style scoped>
.emoji-avaliacao {
  cursor: pointer;
  font-size: 1.5rem;
  padding: 4px;
  border-radius: 50%;
  transition: border 0.2s ease;
}

.emoji-avaliacao.selecionado {
  border: 2px solid green;
}
</style>
